import React, { Component } from 'react';
import {Icon, List, Button,Flex} from 'antd-mobile';
let HEIGHT = document.documentElement.clientHeight * 0.45;
export default class Breeder extends Component {
  constructor (props) {
    super(props);
    this.state = {
    }
  }
  onChange = (value) => {
    value.check = !value.check;
    this.setState({})
  };
  ok = () => {
    let result = this.props.data.filter(item => item.check);
    let res = result.map(o => o.PRODUCTID);
    let desc = (res.length === this.props.data.length) ? 'ALL' : 'NOT_ALL';
    typeof this.props.onConfirm === 'function' && this.props.onConfirm(res,desc)
  };
  cancel = () => {
    const {value,data} = this.props;
    data.forEach(item => {
      item.check = value.indexOf(item.PRODUCTID) >= 0
    });
    typeof this.props.onCancel === 'function' && this.props.onCancel()
  };
  selectAll = () => {
    const {data} = this.props;
    // 当前选择的是否是全部
    let all = data.filter(item => item.check).length === data.length;
    data.forEach(item => {
        item.check = !all
      }
    );
    this.setState({})
  };
  componentWillMount() {
    const {data,value} = this.props;
    data.forEach(item => {
        item.check = value.indexOf(item.PRODUCTID) >= 0
      }
    );
  }

  render() {
    const {data,height} = this.props;
   let all = data.filter(item => item.check).length === data.length;
  return (
    <List>
      <div  style={{height: height || HEIGHT,overflowY:'scroll'}}>
        <List.Item extra={<Icon color="#108EE9"
            type={all?'check': ''}
                          />}
            onClick={()=>{this.selectAll()}}
        >
          全部
        </List.Item>
        {
          data.map((b,index) => {
            return <List.Item extra={<Icon color="#108EE9"
                type={b.check?'check': ''}
                                     />}
                key={index}
                onClick={()=>{this.onChange(b)}}
                   >
                {b.PRODUCTNAME}
            </List.Item>
          })
        }
      </div>

      <div style={{padding: '15px 10px'}}>
        <Flex>
          <Flex.Item>
            <Button onClick={this.cancel}>取消</Button>
          </Flex.Item>
          <Flex.Item>
            <Button onClick={this.ok}
                type="primary"
            >确定</Button>
          </Flex.Item>
        </Flex>
      </div>

    </List>
  )
 }
}
